export const currAccount = (state) => {
    if (state.accountList && state.accountList[state.currAccountIndex]) {
        return state.accountList[state.currAccountIndex];
    }
    return null;
};

export const currAddress = (state) => {
    if (state.accountList && state.accountList[state.currAccountIndex]) {
        if (state.accountList[state.currAccountIndex].userid) {
            return state.accountList[state.currAccountIndex].userid;
        }
        return state.accountList[state.currAccountIndex].address;
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/store/getters.js